import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPaymentMethodState, IPaymentMethodDropdown } from "../../../types/paymentMethods/paymentMethodInterfaces";

export const initialState: IPaymentMethodState = {
  paymentMethodDropdown: []
};

export const paymentMethodSlice = createSlice({
  name: 'paymentMethod',
  initialState,
  reducers: {
    loadingPaymentMethodDropdown: (state, action: PayloadAction<IPaymentMethodDropdown[]>) => {
      state.paymentMethodDropdown = action.payload;
    },
  }
});

export const { loadingPaymentMethodDropdown } = paymentMethodSlice.actions;

export default paymentMethodSlice.reducer;
